/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import SkeletonItem from '@atlaskit/menu/skeleton-item';
import { xcss } from '@atlaskit/primitives/xcss';
import Box from '@atlaskit/primitives/box';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { FlyoutContentContainer } from './MemoizedBoardCreateFlyoutMenuContent.tsx';

const loadingLabel = defineMessage({
	id: 'software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label',
	defaultMessage: 'Loading',
	description: 'The aria-label for the dropdown item that is loading.',
});

export const FlyoutMenuContentFallback = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<FlyoutContentContainer>
			<Box
				paddingBlockStart="space.100"
				xcss={skeletonItemContainerStyles}
				role="menuitem"
				aria-label={formatMessage(loadingLabel)}
			>
				<SkeletonItem hasIcon width="100%" />
			</Box>
			<Box
				paddingBlockStart="space.100"
				xcss={skeletonItemContainerStyles}
				role="menuitem"
				aria-label={formatMessage(loadingLabel)}
			>
				<SkeletonItem hasIcon width="100%" />
			</Box>
		</FlyoutContentContainer>
	);
};

const skeletonItemContainerStyles = xcss({
	height: '56px',
});
